import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {MeshState} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshState';
import {MeshRowHeader} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/MeshRowHeader';
import {IStyles, Styles} from '@mintdata/mint-kit/impl/util/Styles';
import {observer, inject} from 'mobx-react';
import * as React from 'react';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';

const meshRowsHeadersStyles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/Mesh.less');

interface IMeshRowsHeadersProps
{
    ctx?:IWSPMeshContext;
    theme?:IStyles;
    isNested:boolean;
}

@inject('ctx')
@observer
export class MeshRowsHeaders extends React.Component<IMeshRowsHeadersProps>
{
    public componentWillMount():void
    {
        const {theme} = this.props;
        this._initStyles(theme);
    }

    public componentWillReceiveProps(newProps:IMeshRowsHeadersProps):void
    {
        const {theme} = this.props;

        if( theme !== newProps.theme )
            this._initStyles(newProps.theme);
    }

    private _initStyles(theme:IStyles):void
    {
        this.setState({
            styles: Styles.mergeStyles(meshRowsHeadersStyles, theme || {})
        });
    }

    private _renderRowsHeaders():Array<JSX.Element>
    {
        const theme = this.props.theme;
        const {ctx, isNested} = this.props;
        const meshState:MeshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {visibleStartRowIndex, visibleEndRowIndex} = meshState;

        const rows:Array<JSX.Element> = [];
        for( let rowIndex:number = visibleStartRowIndex; rowIndex <= visibleEndRowIndex; rowIndex++ )
            rows.push(<MeshRowHeader key={rowIndex} theme={theme} rowIndex={rowIndex} isNested={isNested}/>);

        return rows;
    }

    public render():JSX.Element
    {
        return <div className={meshRowsHeadersStyles.tableRowsHeaderWrapper}>
            {this._renderRowsHeaders()}
        </div>;
    }
}
